import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
    MmButtonModule,
    MmCheckboxModule,
    MmFlexLayoutModule,
    MmFormFieldModule,
    MmIconModule, MmSpinnerModule,
} from '@metromarkets/components';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { MmExpansionModule } from '~shared/modules/mm-expansion/mm-expansion.module';

import {
    AttributeModalComponent,
    CategoriesFiltersListComponent,
    CategoryChildrenListComponent,
    FilterItemComponent,
    FiltersComponent,
    PriceFilterComponent,
    PromotionListComponent,
    RangeFilterComponent,
    AttributesListComponent, AttributeModalNewDesignComponent,
} from '~app/modules/filters/components';
import { FILTERS_FEATURE_NAME } from './store/feature-name';
import { FiltersEffects, LocalFiltersEffects, metaReducers, reducers } from './store';
import { KebabCaseModule } from '~shared/pipes/kebab-case/kebab-case.module';
import { FilterCounterPipe } from './pipes/filter-count.pipe';
import { DefaultImageModule } from '~shared/directives/default-image/default-image.module';
import { LazyLoadImageModule } from '~shared/directives/lazyload/lazy-load-image.module';
import { CatalogRoutingModule } from '~app/modules/catalog/catalog-routing.module';
import { SearchModule } from '~shared/svgs/search/search.module';
import { TooltipModule } from '~shared/modules/tooltip/tooltip.module';
import { CategoryFacetsCarouselModule } from '~shared/components/category-facets-carousel/category-facets.module';

@NgModule({
    declarations: [
        FiltersComponent,
        PriceFilterComponent,
        AttributeModalComponent,
        AttributeModalNewDesignComponent,
        AttributesListComponent,
        FilterItemComponent,
        FilterCounterPipe,
        PromotionListComponent,
        CategoryChildrenListComponent,
        CategoriesFiltersListComponent,
        RangeFilterComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MmButtonModule,
        MmFormFieldModule,
        MmFlexLayoutModule,
        TranslateModule,
        MmCheckboxModule,
        MatDialogModule,
        MmIconModule,
        QaLocatorsModule,
        MmExpansionModule,
        KebabCaseModule,
        DefaultImageModule,
        LazyLoadImageModule,
        StoreModule.forFeature(FILTERS_FEATURE_NAME, reducers, {metaReducers}),
        EffectsModule.forFeature([FiltersEffects, LocalFiltersEffects]),
        NgxSliderModule,
        CatalogRoutingModule,
        CategoryFacetsCarouselModule,
        SearchModule,
        MmSpinnerModule,
        TooltipModule,
    ],
    exports: [FiltersComponent],
})
export class FiltersModule {
}
